/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CostStatisticDto } from '../../models/cost-statistic-dto';
import { GetLaborCostStatisticRequest } from '../../models/get-labor-cost-statistic-request';

export interface GetLaborCostStatistics$Params {
      body: GetLaborCostStatisticRequest
}

export function getLaborCostStatistics(http: HttpClient, rootUrl: string, params: GetLaborCostStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CostStatisticDto>>> {
  const rb = new RequestBuilder(rootUrl, getLaborCostStatistics.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CostStatisticDto>>;
    })
  );
}

getLaborCostStatistics.PATH = '/v0/costStatistics/labor';
